var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordEyeCrossedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.323,
    height: 15.869,
    viewBox: "0 0 17.323 15.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eye-crossed",
    d: "M16.79,7.075a11.448,11.448,0,0,0-2.432-2.82l2.02-2.02a.721.721,0,1,0-1.02-1.02l-2.2,2.2a8.7,8.7,0,0,0-4.5-1.219A9.558,9.558,0,0,0,.525,7.075a3.541,3.541,0,0,0,0,3.725,11.448,11.448,0,0,0,2.432,2.82l-2.02,2.02a.721.721,0,1,0,1.02,1.02l2.2-2.2a8.7,8.7,0,0,0,4.5,1.222A9.558,9.558,0,0,0,16.79,10.8,3.541,3.541,0,0,0,16.79,7.075ZM1.754,10.045a2.105,2.105,0,0,1,0-2.214,8.168,8.168,0,0,1,6.9-4.193,7.287,7.287,0,0,1,3.439.841L10.644,5.931a3.6,3.6,0,0,0-4.993,4.993L3.984,12.591a9.9,9.9,0,0,1-2.23-2.546Zm9.067-1.107A2.165,2.165,0,0,1,8.657,11.1a2.129,2.129,0,0,1-.927-.216l2.875-2.875A2.129,2.129,0,0,1,10.822,8.938Zm-4.329,0A2.165,2.165,0,0,1,8.657,6.773a2.129,2.129,0,0,1,.927.216L6.709,9.865a2.129,2.129,0,0,1-.216-.927Zm9.067,1.107a8.168,8.168,0,0,1-6.9,4.193A7.287,7.287,0,0,1,5.218,13.4l1.452-1.452a3.6,3.6,0,0,0,4.993-4.993L13.33,5.285a9.9,9.9,0,0,1,2.23,2.546,2.105,2.105,0,0,1,0,2.214Z",
    transform: "translate(0.004 -1.003)",
    fill: "#2d3351",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeCrossedIcon);
export default __webpack_public_path__ + "static/media/password-eye-crossed-icon.f35340cbb7290fe3cfcec6bef186011a.svg";
export { ForwardRef as ReactComponent };